import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'highlight', standalone: false })
export class HighlightPipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) {}

    transform(text: string, query: string): SafeHtml {
        if (!query?.trim()) return text;

        const lower = text.toLowerCase();
        const lowerQ = query.toLowerCase().trim();
        let result = '';
        let i = 0;

        while (i < text.length) {
            const matchIdx = lower.indexOf(lowerQ, i);
            if (matchIdx === -1) {
                result += this.escape(text.slice(i));
                break;
            }
            if (matchIdx > i) result += this.escape(text.slice(i, matchIdx));
            result += `<span class="highlighted">${this.escape(text.slice(matchIdx, matchIdx + query.length))}</span>`;
            i = matchIdx + query.length;
        }

        return this.sanitizer.bypassSecurityTrustHtml(result);
    }

    private escape(s: string): string {
        return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }
}
